import { serophinContactUrl } from "@serophin/shared";
import type { PageProps } from "../pageProps";
import { FAQS, type FaqSection } from "./faqData";

const FaqItem = ({ q, a }: { q: string; a: string }) => (
  <div class="space-y-3">
    <h3 class="text-lg font-semibold text-gray-900 dark:text-white">{q}</h3>
    <p class="text-gray-700 dark:text-gray-300 leading-relaxed" dangerouslySetInnerHTML={{ __html: a }} />
  </div>
);

const FaqGroup = ({ section }: { section: FaqSection }) => (
  <section>
    <h2 class="text-2xl font-bold mb-8 text-gray-900 dark:text-white border-b border-gray-200 dark:border-gray-700 pb-3">{section.category}</h2>
    <div class="space-y-8">
      {section.questions.map((item) => (
        <FaqItem key={item.q} q={item.q} a={item.a} />
      ))}
    </div>
  </section>
);

const FaqFooter = () => (
  <footer class="mt-20 pt-12 border-t border-gray-200 dark:border-gray-700 text-center">
    <p class="text-gray-600 dark:text-gray-400 mb-4">Still have questions?</p>
    <a
      href={serophinContactUrl("nottldr")}
      class="inline-block px-6 py-3 bg-neutral-900 dark:bg-white text-white dark:text-gray-900 font-semibold rounded-lg hover:bg-neutral-800 dark:hover:bg-neutral-100 transition-colors"
    >
      Contact Us
    </a>
  </footer>
);

export const FaqPage = (_props: PageProps) => (
  <div class="min-h-screen rounded-2xl bg-white dark:bg-neutral-900 text-gray-900 dark:text-gray-100">
    <div class="px-6 py-12">
      <header class="mb-12">
        <h1 class="text-4xl font-bold mb-4 text-gray-900 dark:text-white">Frequently Asked Questions</h1>
        <p class="text-gray-600 dark:text-gray-400">Everything you need to know about !tldr</p>
      </header>
      <div class="space-y-16">
        {FAQS.map((section) => (
          <FaqGroup key={section.category} section={section} />
        ))}
      </div>
      <FaqFooter />
    </div>
  </div>
);
